uniform sampler2D uTexture;
uniform bool uHasTexture;
varying float alpha;
varying vec3 vColor;

void main()
{
    vec2 coord = gl_PointCoord - vec2(0.5);
    float dist = length(coord);

    // Soft radial glow fallback (works without texture)
    float radial = 1.0 - smoothstep(0.0, 0.5, dist);
    float core   = 1.0 - smoothstep(0.0, 0.18, dist); // tight white core

    float finalMask = radial;

    // If texture is available, blend it in on top
    if (uHasTexture) {
        vec4 texColor = texture2D(uTexture, gl_PointCoord);
        float texIntensity = (texColor.r + texColor.g + texColor.b) / 3.0;
        // Use texture alpha as additional shaping, but never fully discard
        finalMask = max(radial, texIntensity * texColor.a);
        core = max(core, pow(texIntensity, 3.0) * texColor.a);
    }

    if (finalMask < 0.005) discard;

    // Blend vertex color with white-hot core
    vec3 color = mix(vColor, vec3(1.4, 1.4, 1.4), core * 0.85);

    gl_FragColor = vec4(color, alpha * finalMask * 1.8);
}